import { render, staticRenderFns } from "./slidingButtons.vue?vue&type=template&id=6a43ad72&scoped=true"
import script from "./slidingButtons.vue?vue&type=script&lang=js"
export * from "./slidingButtons.vue?vue&type=script&lang=js"
import style0 from "./slidingButtons.vue?vue&type=style&index=0&id=6a43ad72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43ad72",
  null
  
)

export default component.exports